<!-- 上传图片附件 -->
<template>
  <div class>
    <div v-if="title">{{title}}</div>
    <div class="box" style="position:relative;flex-wrap: wrap;">
      <div
        v-if="!isEditorBox"
        class="imgbox box"
        v-for="(item,index) in imgArr"
        v-bind:key="index"
        @click="previewImg(index)"
        :style="{width:imgWidth+'px'}"
      >
        <img
          v-if="!isActive"
          class="img_delete"
          src="../assets/images/delete.png"
          @click="deleteImg($event,index)"
        >
        <img class="img_item" :src="item.path" :style="{width:imgWidth+'px',height:imgHeight+'px'}">
      </div>
      <!-- <div for="uploads" class="iconfont icon-jiashang img_add imgbox" v-if="isShowAdd">
                <Spin fix v-if="spinShow"></Spin>
                <label class="label" for="uploads"></label>
                <input type="file" id="uploads" style="position: absolute;clip: rect(0px, 0px, 0px, 0px);left: 360px;height: 100px;"
                    accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg" ref="imgs">
      </div>-->
      <div
        v-if="isShowAdd || isActive"
        style="position:relative;"
        :class="isActive?'isActive':''"
        :style="{marginTop:isActive?'-'+ activeHeight+'px':'',width:width100?'100%':''}"
      >
        <slot></slot>
        <Spin fix v-if="spinShow"></Spin>
        <input
          type="file"
          id="uploads"
          style="position: absolute;opacity:0;right: 0px;top:0;height: 100%;"
          :style="{width:imgInputWidth}"
          accept="image/png, image/jpeg, image/gif, image/jpg"
          @change="uploadImg"
          :multiple="multiple"
          ref="imgs"
        >
      </div>
    </div>
    <!-- <Modal v-model="modal" title="图片裁剪" width="584" @on-ok="caijian" @on-cancel="quxiao">
      <photoCut
        @finishend="finishend"
        ref="photocaijian"
        :img="option.img"
        :fixedNumber="fixedNumber"
      ></photoCut>
      <div class="size">图片比例：{{fixedNumber[0]}}:{{fixedNumber[1]}}</div>
    </Modal> -->
    <!--图片预览-->
    <preview-img
      v-if="previewMode"
      :currentIndex="currentIndex"
      :imgArr="newArr"
      v-on:closePreview="closePreview"
    ></preview-img>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import photoCut from "./photoCut.vue";
import previewImg from "./previewImg.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    photoCut,
    previewImg
  },
  props: {
    multiple:{
      type:Boolean,
      default:false
    },
    title: {
      type: String,
      default: ""
    },
    imgArr: Array,
    imgNumber: {
      type: Number,
      default: 0
    },
    imgWidth: {
      default: 100,
      type: Number
    },
    isActive: {
      default: false,
      type: Boolean
    },
    imgHeight: {
      default: 50,
      type: Number
    },
    imgInputWidth: {
      default: "100%",
      type: String
    },
    /* 是否触发 */
    isClick: {
      default: 0,
      type: Number
    },
    /* 是否是编辑器 */
    isEditorBox: {
      default: false,
      type: Boolean
    },
    /* 点击对象e */
    isClickE: null,
    width100: {
      type: Boolean,
      default: false
    }
  },
  //监听属性 类似于data概念
  computed: {
    isShowAdd() {
      return this.imgNumber && this.imgArr.length < this.imgNumber;
    },
    activeHeight() {
      console.log(this.imgHeight);
      return this.imgHeight + 20;
    },
    isShowAdd() {
      return this.imgNumber && this.imgArr.length < this.imgNumber;
    }
  },
  data() {
    //这里存放数据
    return {
      previewMode: false, //是否预览
      currentIndex: 0, //从第几张开始预览
      spinShow: false,
      modal: false,
      filename: "", //存储选上传时择文件的文件名
      option: {
        img: ""
      },
      newArr: []
    };
  },
  //监控data中的数据变化
  watch: {
    isClick() {
      this.uploadImg(this.isClickE);
    }
  },
  //方法集合
  methods: {
    uploadImg(e) {
      let that = this
       console.log('------upload-----')
       console.log(e)
       console.log(this.imgNumber)
      var file = e.target.files;
      var filName = [];
      var filName1 = [];
      for (let i in file) {
        filName.push(file[i]);
      }
      for (let j = 0; j < filName.length - 2; j++) {
        filName1.push(filName[j]);
      }
      filName.splice(filName.length - 2, 2)
      this.filename = filName1.map(item => {
        return item.name;
      });
      console.log(this.filename);
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        this.$Notice.warning({
          title: "图片类型必须是.gif,jpeg,jpg,png,bmp中的一种"
        });
        return false;
      }
      
      
      filName.forEach((item,index) => {
        
        if(index<(this.imgNumber-this.imgArr.length)){
          var reader = new FileReader();
          reader.readAsDataURL(item);
          reader.onload = e => {
            // this.option.img = e.target.result;
          // console.log(e.target.result)
            that.compress(e.target.result,item.size,function(data){
                that.finishend(data)
            })
            

          };
        }
        
      });
    },
    compress(path,size,callback){
      var img = new Image();
            img.src = path;
            img.onload = function(){
                var that = this;
                // 默认按比例压缩
                var w = that.width,
                    h = that.height,
                    scale = w / h;
                //w = obj.width || w;
               // h = obj.height || (w / scale);
                var quality = 0.8;  // 默认图片质量为0.7
                if(size>(1024*1024*4)) quality = (1024*1024*4)/size.toFixed(1)
                //生成canvas
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                // 创建属性节点
                var anw = document.createAttribute("width");
                anw.nodeValue = w;
                var anh = document.createAttribute("height");
                anh.nodeValue = h;
                canvas.setAttributeNode(anw);
                canvas.setAttributeNode(anh);

                //背景区域变成白色
                ctx.fillStyle = "#fff";
                ctx.fillRect(0, 0, w, h);

                ctx.drawImage(that, 0, 0, w, h);
                // 图像质量
                // if(obj.quality && obj.quality <= 1 && obj.quality > 0){
                //     quality = obj.quality;
                // }
                // quality值越小，所绘制出的图像越模糊
                var base64 = canvas.toDataURL('image/jpeg', quality);
                console.log('aftercompress')
                // 回调函数返回base64的值
                callback(base64)
            }
    },
    previewImg(index) {
      this.previewMode = !this.previewMode;
      this.currentIndex = index;
      var img1 = this.imgArr.slice(0, index);
      var img2 = this.imgArr.slice(index);
      this.newArr = img2.concat(img1);
    },
    closePreview() {
      console.log("parent-closePreview");
      this.previewMode = false;
    },
    deleteImg(e, index) {
      e.stopPropagation();
      let communityEntity = {
        id: this.imgArr[index].id,
        index: index
      };
      this.$emit("delPic", communityEntity);
    },
    finishend(data) {
      /**图片存到服务器 */
      console.log("------------走到这里---------");
      console.log(data)
      //let data2 = this.compress(data)
      //console.log(data2)
      // this.$store.commit("updateSpinShow", true);
      let p = {
        source: "materialPicture",
        filename: this.filename,
        communityid: this.$store.state.streetorcommunityid,
        communitytype: this.$store.state.streetorcommunity
      };
      p.base64img = data;
      
      this.$post(this.urlobj.uploadImg, this.qs.stringify(p))
        .then(res => {
          // this.$store.commit("updateSpinShow", false);
          console.log(res)
          let img_obj = {
            path: res.rows[0].defaulturl, // 文件路径
            id: res.rows[0].id // 图片的id
          };
          // this.imgArr.push(img_obj);
          
          this.$Message.success("上传成功");
          //var fileObj = document.getElementById("uploads").files[0];
          console.log('============img_obj=============')
          console.log(img_obj)
          //this.$emit("savePic", fileObj);
          this.$emit("saveImg", img_obj);
          // this.saveImage(res.rows[0].id)
        })
        .catch(error => {
           this.spinShow = false;
        });
    },
    caijian() {
      console.log("-------caijian---------");
      this.$refs.photocaijian.finish("base64");
    },
    quxiao() {
      console.log("-------quxiao---------");
      this.$refs.imgs.value = "";
      this.modal1 = false;
      this.$emit("cancelUpload");
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.label {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.imgbox {
  position: relative;
  margin-right: 30px;
  margin-bottom: 20px;
  box-shadow: 2px 2px 4px 1px rgba(0, 0, 0, 0.1);
}

.img_item {
  // margin-top: 10px;
}
.img_delete {
  position: absolute;
  top: -10px;
  right: -10px;
  height: 20px;
  width: 20px;
}

.size {
  font-size: 14px;
  color: #999;
  margin: 20px 0 85px 0;
}

.isActive {
  opacity: 0;
}
#uploads {
  width: 100%;
}
</style>
